var _defs, _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultUserImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#efefef;}.cls-3{fill:#c9c9c9;}.cls-4{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.26,
    y: 21.01,
    width: 28.43,
    height: 25.9
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 48,
    height: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.33,39.82H8.5c.09-3.82,2.77-5.14,5.58-6.37,6.34-2.79,6.15-4.78,3.62-11.21-.19-.46-.3,1.54-1.24.24-.29-.4-2.66-5.67-.48-4.66s-.31-.87-.17-3.43c.18-3.28.82-7.47,8.32-7.38,3.29,0,1.19,2.17,2.13,1.54,2.89-2,4.84,4,4.6,6.37-.27,2.71-2.74,3.86-.62,2.45,1.74-1.15.21,6.29-.86,5.23-.37-.37-1.19,2.15-1.36,2.66-1.46,4.27-1.24,5.65,2.84,7.45C34.07,34.13,37.57,35.17,38.33,39.82Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("image", {
    width: 2000,
    height: 348,
    transform: "translate(20.17 24) scale(0.06)",
    xlinkHref: "../Documents/Projects/univiser/uni-admin-web/src/assets/images/logo-color.png"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserImage);
export default __webpack_public_path__ + "static/media/default_user_image.3884e1109081224caf175f0a62a3ff09.svg";
export { ForwardRef as ReactComponent };